import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const COLISSIMO_PICKUP_POINT_INTEGRATION_NAME = 'colissimo-pickup-point';
export const ZColissimoPickupPointCredentials = z.object({
    apiKey: z.string().optional(),
});
export const ZColissimoPickupPointSettings = z.object({
    methods: z
        .array(z.object({
        title: z.string(),
        displayName: z.string().optional(),
    }))
        .optional(),
});
export const ZColissimoPickupPointIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(COLISSIMO_PICKUP_POINT_INTEGRATION_NAME),
    category: z.literal('shipping'),
    credentials: ZColissimoPickupPointCredentials,
    settings: ZColissimoPickupPointSettings,
}).shape);
//# sourceMappingURL=colissimo-pickup-point.js.map